module.exports = __webpack_public_path__ + "img/2.42aaa063.png";